"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeWrapper = void 0;
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const web_elements_assets_1 = require("@mindee/web-elements.assets");
const CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
const styles_1 = require("@material-ui/core/styles");
function ThemeWrapper({ children, style = {}, }) {
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: web_elements_assets_1.materialTheme },
        react_1.default.createElement(CssBaseline_1.default, null),
        react_1.default.createElement(Box_1.default, { "data-testid": "theme-wrapper-content", p: "10px", style: style }, children)));
}
exports.ThemeWrapper = ThemeWrapper;
//# sourceMappingURL=theme-wrapper.js.map